import React from "react";
import { Button } from "antd";
import { PaymentElement } from "@stripe/react-stripe-js";
import { useStripePayment } from "hooks";

export const PaymentForm = ({ clientSecret, handlePayment }) => {
  const { handleSubmit, isLoading } = useStripePayment(handlePayment);
  if (!clientSecret) {
    return <></>;
  }
  return (
    <form
      onSubmit={(e: any) => {
        handleSubmit(e);
      }}
    >
      <PaymentElement id="payment-element"></PaymentElement>
      <Button
        htmlType="submit"
        type="primary"
        size={`large`}
        loading={isLoading}
        style={{
          margin: "20px 0px",
          padding: "0px 50px",
          width: "100%",
        }}
      >
        Pay Now
      </Button>
    </form>
  );
};
